import { Typography, Chip } from "@mui/material";
import { CategoryActionsPopover } from "./category-actions-popover";

export const getCategoryColumns = (onEditClick) => [
  {
    accessorKey: "id",
    header: () => <div>ID</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">{row.original.id}</Typography>
    ),
  },
  {
    accessorKey: "name",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Category Name</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem" fontWeight={500}>
        {row.original.name ?? "—"}
      </Typography>
    ),
  },
  {
    accessorKey: "code",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Category Code</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">{row.original.code ?? "—"}</Typography>
    ),
  },
  {
    accessorKey: "description",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Description</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">
        {row.original.description ?? "—"}
      </Typography>
    ),
  },
  {
    accessorKey: "isDefault",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Default</div>,
    cell: ({ row }) => (
      <Chip
        label={row.original.isDefault ? "Yes" : "No"}
        size="small"
        color={row.original.isDefault ? "primary" : "default"}
      />
    ),
  },
  {
    accessorKey: "isActive",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Status</div>,
    cell: ({ row }) => (
      <Chip
        label={row.original.isActive ? "Active" : "Inactive"}
        size="small"
        color={row.original.isActive ? "success" : "error"}
      />
    ),
  },
  {
    accessorKey: "createdBy",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Created By</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">
        {row.original.createdBy ?? "—"}
      </Typography>
    ),
  },
  {
    id: "actions",
    header: () => <div>Actions</div>,
    cell: ({ row }) => (
      <CategoryActionsPopover
        category={row.original}
        onEditClick={onEditClick}
      />
    ),
  },
];
